import { render, staticRenderFns } from "./HrDashboard.vue?vue&type=template&id=b172f4c6&scoped=true&"
import script from "./HrDashboard.vue?vue&type=script&lang=js&"
export * from "./HrDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HrDashboard.vue?vue&type=style&index=0&id=b172f4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b172f4c6",
  null
  
)

export default component.exports